import styled from "styled-components";

export interface TableColumn {
    key: string;
    label: string;
    align?: "left" | "center" | "right";
    render?: (value: any, row: Record<string, any>) => React.ReactNode;
}


interface Props {
    columns: TableColumn[];
    data: Record<string, any>[];
    onRowClick?: (row: Record<string, any>) => void;
    className?: string;
    style?: React.CSSProperties;
}

const TableContainer = styled.table<{ columns: TableColumn[] }>`

    border-collapse: collapse;
    border-spacing: 0;

    td {
        margin: 0;
        vertical-align: top;
        border-bottom: 1px solid #555;
        padding: 1rem 1.5rem;
        border-left: 1px solid #333;
        border-right: 1px solid #333;
    }

    th {
        padding: .5rem 1rem;
        text-align: center;
        border-bottom: 1px solid #555;
        border-top: 1px solid #555;
        border-left: 1px solid #333;
        border-right: 1px solid #333;
    }

    tr:hover {
        background-color: #33333f;
    }
`;

export default function Table({columns, data, onRowClick, className, style}: Props) {

    return (
        <TableContainer columns={columns} className={className} style={style}>
            <thead>
            <tr>
                {columns.map((col, i) => (
                    <th key={i}>
                        <strong>{col.label}</strong>
                    </th>
                ))}
            </tr>
            </thead>
            <tbody>
            {data.map((row, rowIndex) => (
                <tr key={rowIndex} onClick={() => onRowClick && onRowClick(row)}
                    style={{cursor: onRowClick ? "pointer" : "default"}}>
                    {columns.map((col, colIndex) => (
                        <td key={rowIndex + "_" + colIndex} style={{textAlign: col.align || "left"}}>
                            <div className={'element'}>
                                {col.render ? col.render(row[col.key], row) : row[col.key]}
                            </div>
                        </td>
                    ))}
                </tr>
            ))}
            </tbody>
        </TableContainer>
    );


}
